/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncidentLogConfigurationDto } from '../../models/incident-log-configuration-dto';

export interface IncidentLogConfigurationGetConfiguration$Params {
}

export function incidentLogConfigurationGetConfiguration(http: HttpClient, rootUrl: string, params?: IncidentLogConfigurationGetConfiguration$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<IncidentLogConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, incidentLogConfigurationGetConfiguration.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IncidentLogConfigurationDto>;
    })
  );
}

incidentLogConfigurationGetConfiguration.PATH = '/incident-log/configuration';